// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shape-shape-56bd{color:var(--ui-primary-color)}.Shape-shape-56bd.Shape-active-56bd{color:inherit}.Shape-tsum-56bd{color:var(--ui-text-color)}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/Shapes/Shape.module.scss"],"names":[],"mappings":"AAAA,kBACE,6BAAA,CAEA,oCACE,aAAA,CAIJ,iBACE,0BAAA","sourcesContent":[".shape {\n  color: var(--ui-primary-color);\n\n  &.active {\n    color: inherit;\n  }\n}\n\n.tsum {\n  color: var(--ui-text-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shape": `Shape-shape-56bd`,
	"active": `Shape-active-56bd`,
	"tsum": `Shape-tsum-56bd`
};
module.exports = ___CSS_LOADER_EXPORT___;
